/* eslint-disable */
import {
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
  Button,
  Dropdown,
  Modal,
  message,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  VerticalAlignBottomOutlined,
  LoadingOutlined,
  MenuOutlined,
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  FilePptOutlined,
  FileAddOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import AddModal from "./component/addModal";
import EditModal from "./component/editModal";
import BalanceModal from "./component/BalanceModal";
import updataIcon from "@/assets/images/icons/updata.png";
import PDFModal from "./component/pdfModal";
import dayjs from "dayjs";
export default function BankIndex() {
  const addModalRef = useRef(null);
  const EditModalRef = useRef(null);
  const PDFModalRef = useRef();
    const [currentRecord, setCurrentRecord] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [txtLoading, setTxtLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [balanceOpen, setBalanceOpen] = useState(false);
  const [balanceRecord, setBalanceRecord] = useState(null);
  const [ownerList, setOwnerList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  // 处理选项变化
  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    setColumns(
      initColumns.map((item) => ({
        ...item,
        hidden: !checkedValues.includes(item.dataIndex),
      })),
    );
  };

  const showModal = () => {
    addModalRef.current?.setModelAdd();
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  const handleMenuClick = async (e, record) => {
    if (e.key === "Edit") {
      EditModalRef.current?.open(record);
    }
    if (e.key === "Delete") {
      Modal.confirm({
        title: "Confirm Delete",
        content: `Are you sure you want to delete  items?`,
        okText: "Delete",
        okType: "danger",
        cancelText: "Cancel",
        onOk: async () => {
          try {
            const ids = record.bankId;
            const res = await http.get(api.getBankDelete, {
              params: { bankIds: ids },
            });

            if (res.code === "1") {
              message.success("Delete Successfully.");
              // setSelectedRowKeys([]);
              setRefreshKey(Date.now());
            } else {
              message.error(res.msg || "Delete Failed.");
            }
          } catch (err) {
            message.error("Request Error");
          }
        },
      });
    }
    if (e.key === "DownloadPDF") {
      if (pdfLoading) return;
      setPdfLoading(true);
      try {
        const res = await http.get(api.getBankPDFById, {
          params: { bankId: record.bankId },
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Bank_${record.bankId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        message.success("PDF Downloaded");
      } catch (err) {
        console.error(err);
        message.error("Failed to download PDF");
      } finally {
        setPdfLoading(false);
      }
    }
    if (e.key === "Upload") {
      setBalanceRecord(record);
      setBalanceOpen(true);
    }
  };


    const handleAmountClick = (record) => {
    setCurrentRecord(record);
    PDFModalRef?.current?.setModalOpen(true);
  };



  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: (keys) => setSelectedRowKeys(keys),
  // };
  const handleExport = async () => {
    if (exportLoading) return; // 防止重复点击

    setExportLoading(true);

    try {
      const params = {
        page: pagination.current,
        count: pagination.pageSize,
        ...tableHead,
      };

      // 如果选中了行 → 只导出选中的 bankId
      // if (selectedRowKeys.length > 0) {
      //   params.bankIds = selectedRowKeys.join(",");
      // }

      const response = await http.get(api.getBankExcel, {
        params,
        responseType: "blob",
      });

      const blob = new Blob([response], { type: "application/vnd.ms-excel" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `Bank_List_${moment().format("MM/DD/YYYY")}.xlsx`;
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      message.error("Failed to export file");
    } finally {
      setExportLoading(false);
    }
  };
  const handleTxt = async () => {
    if (txtLoading) return;
    setTxtLoading(true);
    try {
      const res = await http.get(api.getBankByTxt, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "BankData.txt");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success("TXT Downloaded");
    } catch (err) {
      console.error(err);
      message.error("Failed to download TXT");
    } finally {
      setTxtLoading(false);
    }
  };

  const content2 = (
    <div
      onClick={!exportLoading ? handleExport : undefined}
      style={{ cursor: exportLoading ? "not-allowed" : "pointer" }}
    >
      {exportLoading ? "Exporting..." : "Export to CSV"}
    </div>
  );
  const content3 = (
    <div
      onClick={!txtLoading ? handleTxt : undefined}
      style={{ cursor: txtLoading ? "not-allowed" : "pointer" }}
    >
      {txtLoading ? "Exporting..." : "Export to TXT"}
    </div>
  );
  // table
  const initTableHead = {
    role: null,
    module: null,
    firstName: null,
    dateTimeRequest: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const initColumns = [
    // {
    //   title: "#",
    //   key: "#",
    //   dataIndex: "#",
    //   hidden: false,
    //   align: "center",
    //   width: 50,
    // },
    {
      title: "Action",
      key: "action",
      dataIndex: "bankId",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) => {
        const menuItems = [
          commonFn.btnAuthorityFlag("DownloadPDF") && {
            key: "DownloadPDF",
            icon: pdfLoading ? (
              <LoadingOutlined />
            ) : (
              <FilePptOutlined style={{ color: "#00c0ef", fontSize: 17 }} />
            ),
            label: <div>{pdfLoading ? "Downloading..." : "DownloadPDF"}</div>,
          },
          commonFn.btnAuthorityFlag("EditBankInformation") && {
            key: "Edit",
            icon: <EditOutlined style={{ color: "#00c0ef", fontSize: 17 }} />,
            label: <div>Edit Bank Information</div>,
          },
          commonFn.btnAuthorityFlag("DeleteBankInformation") && {
            key: "Delete",
            icon: (
              <DeleteOutlined style={{ color: "#00c0ef", fontSize: 17 }} />
            ),
            label: <div>Delete Bank Information</div>,
          },
          record.baiFile === 0 &&
            commonFn.btnAuthorityFlag("UploadBankStatement") && {
              key: "Upload",
              icon: (
                <FileAddOutlined style={{ color: "#00c0ef", fontSize: 17 }} />
              ),
              label: <div>Upload bank Statement</div>,
            },
        ].filter(Boolean);

        return (
          (menuItems.length > 0 && (
            <Dropdown
              menu={{
                items: menuItems,
                onClick: (e) => handleMenuClick(e, record),
              }}
              trigger={["click"]}
            >
              <MenuOutlined
                style={{ cursor: "pointer", fontSize: 16, color: "#0e78a9" }}
              />
            </Dropdown>
          )) ||
          null
        );
      },
    },
 {
      title: "Account Owner",
      dataIndex: "ownerName",
      titleType: "Select",
      width: 160, 
      selectOptions: ownerList,
      onChange: (e) => tableFilterFn(e, "ownerId", "Select"),
    },

    {
      title: "Entity Name",
      dataIndex: "trustName",
      titleType: "Input",
      width: 180,
      onChange: (e) => tableFilterFn(e, "trustName"),
    },

    {
      title: "Managing Company",
      dataIndex: "companyName",
      titleType: "Input",
      width: 180,
      onChange: (e) => tableFilterFn(e, "companyName"),
    },

    {
      title: "Bank Name",
      dataIndex: "name",
      titleType: "Input",
      width: 180,
      onChange: (e) => tableFilterFn(e, "name"),
    },
{
      title: "Bank Address",
      dataIndex: "addressCityState",
      titleType: "Input",
      width: 200,
      onChange: (e) => tableFilterFn(e, "addressCityState"),
    },

    

    {
      title: "Routing #",
      dataIndex: "transitCp",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "transitCp"),
    },
    {
      title: "Account #",
      dataIndex: "crAcct",
      titleType: "Input",
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "crAcct"),
    },
    
 {
      title: "Bank",
      dataIndex: "bank",
      titleType: "Input",
      width:80,
      onChange: (e) => tableFilterFn(e, "bank"),
    },
             {
      title: "Cash GL",
      dataIndex: "glAcct",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "glAcct"),
    },
    {
      title: "Remark",
      dataIndex: "remark",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "remark"),
    },
{
  title: "Balance",
  dataIndex: "balance",
  titleType: "Input",
  isSorter: true,
  isAmountFlag: true,
  sortterMultiple: 3,
  hidden: !commonFn.btnAuthorityFlag("balance"), 
  onChange: (e) => tableFilterFn(e, "balance"),
  render: (text, record) => {
    if (text == null || text === "") return "-";

    const formattedDate = record.statementDate
      ? dayjs(record.statementDate).format("MM/DD/YYYY")
      : "";

    return (
      <div>
        <div
          onClick={() =>
            handleAmountClick({ ...record, pageName: "Bank" })
          }
          style={{
            color: "#1890ff",
            cursor: "pointer",
          }}
        >
          {commonFn.amountToDollarFn(text)}
        </div>

        {formattedDate && (
          <div style={{ fontSize: 12, color: "#1890ff" }}>
            {formattedDate}
          </div>
        )}
      </div>
    );
  },
},
   
    {
      title: "Active",
      dataIndex: "active",
      titleType: "Select",
       width:80,
      selectOptions: [
        { value: "1", label: "Active" },
        { value: "0", label: "Inactive" },
      ],
      onChange: (value) => tableFilterFn(value, "active", "Select"),
      render: (value) => (value === 1 ? "Active" : "Inactive"),
    },
    {
      title: "Bai",
      dataIndex: "baiFile",
      titleType: "Select",
      width:80,
      selectOptions: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
      onChange: (e) => tableFilterFn(e, "baiFile", "Select"),
      render: (value) => (value === 1 ? "Yes" : "No"),
    },
    {
      title: "Positive Pay",
      dataIndex: "positivePay",
      titleType: "Select",
      width: 80,
      selectOptions: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
      onChange: (e) => tableFilterFn(e, "positivePay", "Select"),
      render: (value) => (value === 1 ? "Yes" : "No"),
    },
  ];

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.get(api.getBankList, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
      key: item.bankId,
    }));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  // const handleTableChange = (pagination, filters, sorter) => {
  //   getTableListFn(pagination.current, pagination.pageSize, tableHead);
  // };
  const handleTableChange = (pagination, filters, sorter) => {
    const { field: orderField, order: orderType, columnKey } = sorter;
    if (columnKey === "trust") {
      const tableHeadTemp = {
        ...tableHead,
        orderField,
        orderType,
      };
      getTableListFn(pagination.current, pagination.pageSize, tableHeadTemp);
    } else {
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    }
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

  const getOwnerIdList = async () => {
    const response = await http.get(api.getOwnerDictList);
    setOwnerList((response?.data || [])?.map(item => ({label: item?.titleName, value: item?.ownerId})));
  };

  useEffect(() => {
    getOwnerIdList();
  }, []);

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25);
  }, [refreshKey]);

  useEffect(() => {
    if (ownerList.length) {
      setColumns(initColumns);
    }
  }, [ownerList]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          {commonFn.btnAuthorityFlag("New") && (
            <Button className="btnNew" onClick={showModal}>
              <PlusOutlined />
              New
            </Button>
          )}
        </div>
        <div className="min-width">
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={() => setRefreshKey(+new Date())}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>

            <Radio.Button value="c">
              <Popover content={content2} title="" trigger="click">
                <VerticalAlignBottomOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>

            <Radio.Button value="d">
              <Popover content={content3} title="" trigger="click">
                <img
                  src={updataIcon}
                  alt="export"
                  style={{
                    width: 16,
                    height: 16,
                    marginRight: 4,
                    cursor: "pointer",
                  }}
                />
                <span className="ft12">{txtLoading ? "Exporting..." : ""}</span>
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableCss="maintenanceTable"
        rowKey="bankId"
        // rowSelection={rowSelection}
      />
      <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />

      {/* ResetModal */}
      <EditModal
        ref={EditModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />

      <BalanceModal
        record={balanceRecord}
        open={balanceOpen}
        onClose={() => setBalanceOpen(false)}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />

        <PDFModal ref={PDFModalRef} record={currentRecord} />
    </div>
  );
}
